// extracted by mini-css-extract-plugin
export var container = "SimpleCard-module--container--BA5jn";
export var icon = "SimpleCard-module--icon--1xpAV";
export var center = "SimpleCard-module--center--3vVEC";
export var full = "SimpleCard-module--full--EomFq";
export var content = "SimpleCard-module--content--3n9g1";
export var short = "SimpleCard-module--short--1HTDl";